import { render, staticRenderFns } from "./AppSuccessModal.vue?vue&type=template&id=566feaae&"
import script from "./AppSuccessModal.vue?vue&type=script&lang=js&"
export * from "./AppSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppModal: require('/builds/mytia/mege-educacional/components/AppModal.vue').default})
